import { UserRole } from "Infrastructure/Api/Api";
import { AuthenticatedLayout } from "Infrastructure/Components/AuthenticatedLayout";
import { QuestsPage } from "Infrastructure/Pages/Quests/QuestsPage";
import { RequestsPage } from "Infrastructure/Pages/Requests/RequestsPage";
import { PlayersPage } from "Infrastructure/Pages/Users/PlayersPage";
import { AppRouting, getRoute } from "Infrastructure/Utils/UrlUtils";
import { Box, CircularProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

const DashboardPage = lazy(() =>
  import("Dashboard/Pages/DashboardPage").then((module) => ({
    default: module.DashboardPage,
  })),
);

const RewardsPage = lazy(() =>
  import("Rewards/Pages/RewardsPage").then((module) => ({
    default: module.RewardsPage,
  })),
);

const Error403Page = lazy(() =>
  import("Infrastructure/Pages/Error403Page").then((module) => ({
    default: module.Error403Page,
  })),
);

const Error404Page = lazy(() =>
  import("Infrastructure/Pages/Error404Page").then((module) => ({
    default: module.Error404Page,
  })),
);

const LoadingFallback = () => (
  <Box
    display="flex"
    position="fixed"
    top={0}
    left={0}
    right={0}
    bottom={0}
    justifyContent="center"
    alignItems="center"
  >
    <CircularProgress />
  </Box>
);

const appRoutes = [
  {
    path: "/",
    element: (
      <AuthenticatedLayout>
        <Suspense fallback={<LoadingFallback />}>
          <DashboardPage />
        </Suspense>
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Dashboard),
    element: (
      <AuthenticatedLayout>
        <Suspense fallback={<LoadingFallback />}>
          <DashboardPage />
        </Suspense>
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Players),
    element: (
      <AuthenticatedLayout>
        <Suspense fallback={<LoadingFallback />}>
          <PlayersPage />
        </Suspense>
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Quests),
    element: (
      <AuthenticatedLayout>
        <Box>
          <QuestsPage />
        </Box>
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Rewards),
    element: (
      <AuthenticatedLayout>
        <Suspense fallback={<LoadingFallback />}>
          <RewardsPage />
        </Suspense>
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Requests),
    element: (
      <AuthenticatedLayout allowedRoles={[UserRole.GameMaster]}>
        <RequestsPage />
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Players),
    element: (
      <AuthenticatedLayout allowedRoles={[UserRole.GameMaster]}>
        <PlayersPage />
      </AuthenticatedLayout>
    ),
  },
  {
    path: getRoute(AppRouting.Error403),
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Error403Page />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Error404Page />
      </Suspense>
    ),
  },
];

export const appRouter = createBrowserRouter(appRoutes, {
  basename: import.meta.env.VITE_BASE_URL,
});
